

























import Vue from "vue";

export default Vue.extend({
  name: "PendingInvitesCard",
  props: {
    pendingPlayerInviteCount: { type: Number }
  },
  methods: {
    redirectToCalendar() {
      this.$router.push("/calendar");
    }
  }
});
